import consent from './consent';

export default consent;
